import { render, staticRenderFns } from "./PeraltaClientSignUpFlow.vue?vue&type=template&id=5bdec40e&"
import script from "./PeraltaClientSignUpFlow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PeraltaClientSignUpFlow.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PeraltaClientSignUpFlow.vue?vue&type=style&index=0&id=5bdec40e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports